import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@mainstage/core-plugin-api';

import {
  rootRouteRef,
  taskListRouteRef,
  templateIndexRouteRef,
  templateEditorRouteRef,
  actionsRouteRef,
  taskRouteRef,
  iamRouteRef,
  dynamicDataProvidersRouteRef,
} from './routes';
import {
  developerToolsApiRef,
  DeveloperToolsClient,
} from './api/DeveloperToolsApi';
import { controlPlaneApiRef } from './api/controlPlaneApiRef';
import { ControlPlaneClient } from '@agilelab/plugin-wb-control-plane-common';
import {
  workflowManagementApiRef,
  WorkflowManagementClient,
} from './api/WorkflowManagementApi';

export const platformSettingsPlugin = createPlugin({
  id: 'wb-platform-settings',
  routes: {
    root: rootRouteRef,
    templateIndexRouteRef: templateIndexRouteRef,
    iamRouteRef: iamRouteRef,
    taskListRouteRef: taskListRouteRef,
    templateEditorRouteRef: templateEditorRouteRef,
    actionsRouteRef: actionsRouteRef,
    taskRouteRef: taskRouteRef,
    dynamicDataProvidersRouteRef: dynamicDataProvidersRouteRef,
  },
  apis: [
    createApiFactory({
      api: workflowManagementApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new WorkflowManagementClient(discoveryApi, fetchApi),
    }),
    createApiFactory({
      api: developerToolsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new DeveloperToolsClient({ discoveryApi, fetchApi }),
    }),
    createApiFactory({
      api: controlPlaneApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, fetchApi, identityApi }) =>
        new ControlPlaneClient({
          discoveryApi,
          fetchApi,
          getToken: async () => (await identityApi.getCredentials()).token,
        }),
    }),
  ],
});

/**
 * The Router and main entrypoint to the plugin.
 *
 * @public
 */
export const PlatformSettingsPage = platformSettingsPlugin.provide(
  createRoutableExtension({
    name: 'PlatformSettingsPage',
    component: () => import('./components/Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
